<!-- src/App.vue -->
<template>
  <VApp>
    <!-- se usas app-bar com prop "app", adiciona VMain para gerir offset -->
    <VMain>
      <RouterView />
    </VMain>
  </VApp>
</template>

<script setup>
defineOptions({ name: 'App' })
</script>

<style>
@font-face {
  font-family: 'Montserrat';
  src: local('Montserrat'),
       url('./assets/fonts/Montserrat-Regular.ttf') format('truetype');
}
</style>
